import $ from "jquery";
import "./boostrap/boostrap-imports";
import "jquery-hoverintent";
import "./components/dynamic-bootstrap-components";
import "./components/responsive";
import PageLazyLoad from "./components/Lazyload";
import PageLoader from "./components/PageLoader";
window.targetxTheme = window.targetxTheme || {};
targetxTheme.pageLazyLoad = new PageLazyLoad({
  selector: ".lazyload"
});
targetxTheme.pageLoader = new PageLoader();
jQuery(function($2) {
  const $passwordInput = $2("#field-password");
  const $strengthMeter = $2(".password-strength-meter");
  const $strengthBar = $strengthMeter.find(".strength-bar");
  if ($passwordInput.length === 0) {
    return;
  }
  const checkPasswordStrength = (password) => {
    let score = 0;
    const hasLowerCase = /[a-z]/.test(password);
    const hasUpperCase = /[A-Z]/.test(password);
    const hasNumbers = /[0-9]/.test(password);
    const hasSpecialChars = /[^a-zA-Z0-9]/.test(password);
    const isLongEnough = password.length >= 8;
    if (hasLowerCase) score++;
    if (hasUpperCase) score++;
    if (hasNumbers) score++;
    if (hasSpecialChars) score++;
    if (isLongEnough) score++;
    return score;
  };
  $passwordInput.on("input", function() {
    const password = $2(this).val();
    if (password.length === 0) {
      $strengthMeter.hide();
      return;
    }
    $strengthMeter.show();
    const score = checkPasswordStrength(password);
    let strengthClass = "";
    switch (score) {
      case 0:
      case 1:
        strengthClass = "is-very-weak";
        break;
      case 2:
        strengthClass = "is-weak";
        break;
      case 3:
      case 4:
        strengthClass = "is-medium";
        break;
      case 5:
        strengthClass = "is-strong";
        break;
      default:
        strengthClass = "";
    }
    $strengthMeter.removeClass("is-very-weak is-weak is-medium is-strong").addClass(strengthClass);
  });
});
